/**
 * Created by Xuz on 2020/02/10.
 * xuz@live.cn
 *
 * 流程SVG文件反解类，原始SVG在生成真正的XML格式时有部分JS的附加内容与工具条之类的内容会被删除掉
 */
import * as WFC from './WFConstants'

class WFDeparser {
  /**
   * 删除指定节点的全部子
   */
  removeChildren (node) {
    let children = node.childNodes
    for (let i = children.length - 1; i >= 0; i--) {
      node.removeChild(children.item(i))
    }
  }

  /**
   * 移除根部事件
   */
  removeSvgAttributes (svgNode) {
    svgNode.removeAttribute('xmlns:svgjs')
  }

  /**
   * XML的内容头部
   */
  getXmlHeader () {
    return '<?xml version="1.0" encoding="utf-8"?>'
  }

  /**
   * 生成合法的SVG源码，供修改或者其它地方调用，只解析出干净的SVG代码
   */
  deparse (node) {
    let text = ''
    const type = node.nodeType

    if (type === WFC.XML_DF_ELEMENT_NODE) {
      let nodeId = node.getAttribute('id')
      if (nodeId === 'ToolBarContainer') {
        this.removeChildren(node)
      }
      let name = node.tagName
      // 根上的内容也需要适当清空
      if (name === 'svg') {
        this.removeSvgAttributes(node)
      }
      let attrs = node.attributes
      let children = node.childNodes

      text += '<' + name

      for (let i = attrs.length - 1; i >= 0; i--) {
        let attr = attrs.item(i)
        if (attr.nodeName === 'svgjs:data') {
          continue
        }
        let nodeName = attr.nodeName
        if (name === 'image' && nodeName === 'href') {
          // 解决中标麒麟火狐下图标不显示问题
          nodeName = 'xlink:href'
        }
        text += ' ' + nodeName + '="' + attr.nodeValue + '"'
      }

      if (children.length > 0) {
        text += '>'
        for (let i = 0; i < children.length; i++) {
          text += this.deparse(children.item(i))
        }
        text += '</' + name + '>'
      } else {
        text += '/>'
      }
    } else if (type === WFC.XML_DF_ATTRIBUTE_NODE) {
      text += 'Attribute: ' + node.getName() + '="' + node.getValue() + '"'
    } else if (type === WFC.XML_DF_TEXT_NODE) {
      var temp = node.data
      if (temp.match(/^\s*$/)) {
        text = ''
      } else {
        text = (temp) + ''
      }
    } else if (type === WFC.XML_DF_CDATA_SECTION_NODE) {
      text += '<![CDATA[' + node.data + ']]>'
    } else if (type === WFC.XML_DF_ENTITY_REFERENCE_NODE) {
      text += 'Entity Reference\n'
    } else if (type === WFC.XML_DF_ENTITY_NODE) {
      text += 'Entity\n'
    } else if (type === WFC.XML_DF_PROCESSING_INSTRUCTION_NODE) {
      text += 'Processing Instruction\n'
    } else if (type === WFC.XML_DF_COMMENT_NODE) {
      text += '<!--' + node.data + '-->\n'
    } else if (type === WFC.XML_DF_DOCUMENT_NODE) {
      text += 'Document\n'
    } else if (type === WFC.XML_DF_DOCUMENT_TYPE_NODE) {
      text += 'Document Type\n'
    } else if (type === WFC.XML_DF_DOCUMENT_FRAGMENT_NODE) {
      text += 'Document Fragment\n'
    } else if (type === WFC.XML_DF_NOTATION_NODE) {
      text += 'Notation\n'
    } else {
      text += 'Unrecognized type: ' + type + '\n'
    }
    return text
  }
}

export default WFDeparser
